export default __webpack_public_path__ + "static/media/doctors-4.d2e578c3.jpg";